import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './script-image.component.scss';
var ScriptImage = /** @class */ (function (_super) {
    tslib_1.__extends(ScriptImage, _super);
    function ScriptImage(element) {
        return _super.call(this, element) || this;
    }
    ScriptImage.prototype.init = function () {
        this.container = this.element;
        this.detect();
    };
    ScriptImage.prototype.bindEvents = function () {
        var _this = this;
        window.addEventListener('resize', function (event) {
            console.log(event);
            _this.detect();
        });
    };
    ScriptImage.prototype.detect = function () {
        var image = this.element.getAttribute('data-desktop');
        var width = window.screen.width;
        if (width > 768) {
            image = this.element.getAttribute('data-desktop');
        }
        else {
            if (width > 480) {
                image = this.element.getAttribute('data-tablet');
            }
            else {
                image = this.element.getAttribute('data-mobile');
            }
        }
        this.container.style.backgroundImage = "url('" + image + "')";
    };
    return ScriptImage;
}(Base));
export { ScriptImage };



//////////////////
// WEBPACK FOOTER
// ./components/script-image/script-image.component.ts
// module id = 485
// module chunks = 0